module.exports = __webpack_public_path__ + "resources/icon_94_gonglueno.124ae937e50456fb.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-manage/manage-dialog/img/icon_94_gonglueno.png
// module id = 623
// module chunks = 0 1 2 3